// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FmtMbmzNUoMwvQkWjDw7{width:100%;display:flex}.S5JvNxqmXmAmgpBC3rim{padding:2px 0;font-size:13px;font-style:normal;font-weight:500;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionsWrap": `FmtMbmzNUoMwvQkWjDw7`,
	"button": `S5JvNxqmXmAmgpBC3rim`
};
export default ___CSS_LOADER_EXPORT___;
